import { heroEquipment } from "../HeroEquipment";

export const dzieciZagłady = {
  heroes: {
    Wtajemniczony: {
      id: 0,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 85,
      number: 1,
      equipmentList: heroEquipment["Kult Dzieci Zagłady"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarnoksięstwo",
        "Dowódca",
        "Mag (Dziedzina Nurgla)",
        "Stygmat Chaosu",
        "Twardziel",
      ],
      exp: 20,
      skills: [0, 2, 3, 5],
    },
    Akolita: {
      id: 1,
      startingEquipment: ["Sztylet", "Korbacz"],
      cost: 45,
      number: 2,
      equipmentList: heroEquipment["Kult Dzieci Zagłady"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Stygmat Chaosu", "Twardziel"],
      exp: 8,
      skills: [0, 3, 5],
    },
    Opętany: {
      id: 2,
      startingEquipment: ["Broń naturalna"],
      cost: 180,
      number: 1,
      equipmentList: {},
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 0, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 7, 0, 5, 5, 4, 5, 5, 10],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Furia",
        "Głód trzewi",
        "Ograniczony",
        "Opętany",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
        "Żywiołak Chaosu",
      ],
      exp: 8,
      skills: [0, 3, 5],
    },
    Kultysta: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 12,
      equipmentList: heroEquipment["Kult Dzieci Zagłady"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Żywa tarcza"],
    },
    Nurglingi: {
      id: 4,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 35,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 3, 4, 1, 3, 1, 7],
        Maksymalna: [4, 2, 0, 3, 4, 1, 3, 1, 7],
      },
      rules: ["Demon", "Stygmaty Nurgla (odór, rój much)"],
    },
    Plagogor: {
      id: 5,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 55,
      number: 3,
      equipmentList: heroEquipment["Kult Dzieci Zagłady"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 3, 4, 4, 1, 3, 1, 7],
        Maksymalna: [6, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: ["Ranger", "Stygmat Chaosu", "Trudny do zabicia"],
    },
    "Ogr Chaosu": {
      id: 6,
      startingEquipment: ["Sztylet","Broń wielka"],
      cost: 180,
      number: 1,
      equipmentList: heroEquipment["Kult Dzieci Zagłady"].Ogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Ograniczony",
        "Przepastne trzewia",
        "Strach",
        "Stygmat Chaosu",
        "Tempy",
        "Wielkolud",
      ],
    },
    "Troll Chaosu": {
      id: 7,
      startingEquipment: ["Broń naturalna"],
      cost: 200,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 5, 4, 3, 1, 3, 4],
        Maksymalna: [6, 3, 1, 5, 4, 3, 1, 3, 4],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Głupota",
        "Nieświadomy",
        "Niezłomny",
        "Przepastne trzewia",
        "Regeneracja",
        "Strach",
        "Stygmat Chaosu",
        "Wielkolud",
        "Żrąca plwocina",
        "Żywiołak Chaosu",
      ],
    },
    Zarazowóz: {
      id: 8,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        "Rumak Chaosu": [8, 3, 0, 4, "-", "-", 3, 1, 5],
        "Rumak Chaosu ": [8, 3, 0, 4, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Zarazowóz"],
    },
  },
  limit: 600,
  minModels: 3,
  maxModels: 12,
  name: "Kult Dzieci Zagłady",
  nature: "Chaotyczna",
  armyRules: [
    "Kontakty handlowe (1)",
    "Niewolnicy ciemności",
    "Oko Chaosu",
    "Rozrzutność",
    "Zamożność",
    "Znak Chaosu (Potworny Lud Nurgla)",
  ],
  mercenaries: ["Skryba", "Szpieg", "Trefniś", "Woźnica"],
};
